import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/OverflowMenu/sgds-overflow-menu";
import { register } from "../../utils/ce-registry";

register("sgds-overflow-menu", Component);

export default createComponent({
  react: React,
  tagName: "sgds-overflow-menu",
  elementClass: Component,
  events: {}
});
